module.exports = __webpack_public_path__ + "static/media/uberEats-3c.0557b032.png";